import React, { useState, useContext } from "react";
import { ImCross } from "react-icons/im";
import moment from "moment";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import APopover from "../../../../common/a-popover";
import SelectSearchInputParam from "views/pages/manage/unAssigned/studentCharges/studentFiltersandwidget/SelectSearchInputParam";
import { ReactComponent as Search } from "assets/img/svg/SearchIcon.svg";

import { searchInputParams, emptySearchFields, styles } from "./constants";
import { ReceiptListContext } from "./context";
import FilterMenu from "./FilterMenu";

const Filters = ({
  crossInputHandler,
  searchInputValueHandler,
  isLoading,
  businessAreaOptions,
  updateReceiptsList,
}) => {
  const { setGlobalFilter, filterCount } = useContext(ReceiptListContext);

  const applyFilters = (newFilters) => {
    const filters = {
      ...newFilters,
      ...(newFilters.startDate && {
        startDate: new Date(newFilters.startDate).toISOString(),
      }),
      ...(newFilters.endDate && {
        endDate: new Date(
          moment(newFilters.endDate).endOf("day")
        ).toISOString(),
      }),
    };

    //  set globalFilters and call API
    setGlobalFilter((prev) => ({ ...prev, ...filters }));
    updateReceiptsList(filters);
  };

  return (
    // <div className="d-flex flex-column">
    <div className="d-flex">
      <SearchInput
        searchInputValueHandler={searchInputValueHandler}
        onCancel={crossInputHandler}
        errorMsg={true}
        isLoading={isLoading}
      />

      <div className="d-flex justify-content-end">
        <APopover
          buttonComponent={(onClick, styles) => (
            <AButton
              className="tiny-semi-bold color-dark"
              disabled={isLoading}
              onClick={onClick}
              updatedStyle={{
                minWidth: "61px",
                ...(filterCount > 0
                  ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                  : styles),
              }}
            >
              Filters {filterCount > 0 && <>( {filterCount} )</>}
            </AButton>
          )}
          menuComponent={(closeForm) => (
            <>
              <FilterMenu
                businessAreaOptions={businessAreaOptions}
                closeForm={closeForm}
                applyFilters={applyFilters}
              />
            </>
          )}
          maxHeight={"calc(100vh - 180px)"}
        />
      </div>
    </div>
    // </div>
  );
};

export default Filters;

const SearchInput = ({
  searchInputValueHandler,
  onCancel,
  errorMsg = false,
  isLoading,
}) => {
  const { globalFilter, setGlobalFilter } = useContext(ReceiptListContext);

  const [inputValue, setInputValue] = useState("");

  const selectedSearchFieldProperties =
    searchInputParams[globalFilter?.searchField];
  const searchInputValue = globalFilter?.[globalFilter?.searchField];

  const searchHandler = () => {
    if (
      searchInputValue?.length === selectedSearchFieldProperties?.validLength
    ) {
      searchInputValueHandler();
    }
  };

  const onChangeHandler = (value) => {
    setGlobalFilter((prev) => ({ ...prev, [prev?.searchField]: value }));
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchHandler();
    }
  };

  const handlePaste = (e) => {
    let pastedText = e.clipboardData?.getData("text/plain");

    if (["psid", "applicationId"].includes(globalFilter?.searchField)) {
      pastedText = pastedText?.replace(/\D/g, "");
    }
    setGlobalFilter((prev) => ({ ...prev, [prev?.searchField]: pastedText }));
    e.preventDefault();
  };

  const clickHandler = () => {
    if (inputValue !== "") {
      searchInputValueHandler(inputValue);
    }
  };

  return (
    <div
      className="d-flex flex-column"
      style={{ pointerEvents: isLoading ? "none" : "all" }}
    >
      <div style={{ position: "relative", minHeight: "35px" }}>
        <styles.StyledInput
          className="search-input"
          id="inputValue"
          value={searchInputValue}
          placeholder={selectedSearchFieldProperties?.placeholder}
          onChange={(e) => {
            onChangeHandler(e.target.value);
          }}
          onKeyDown={onKeyDownHandler}
          inputValue={inputValue}
          maxLength={selectedSearchFieldProperties?.validLength}
          onPaste={handlePaste}
          onKeyPress={(e) => {
            if (
              ["psid", "applicationId"].includes(globalFilter?.searchField) &&
              !/^[0-9]*$/.test(String.fromCharCode(e.charCode))
            ) {
              e.preventDefault();
              return;
            }
          }}
          errorMsg={errorMsg}
          searchInputValue={searchInputValue}
          selectedSearchFieldProperties={selectedSearchFieldProperties}
        />

        {errorMsg && searchInputValue?.length > 0 && (
          <ImCross
            onClick={() => {
              // setInputValue('')
              onCancel();
            }}
            style={styles.crossIconStyle}
          />
        )}
        {!errorMsg && (
          <ImCross
            onClick={() => {
              setInputValue("");
              onCancel();
            }}
            style={styles.crossIconStyle}
          />
        )}
        {errorMsg && searchInputValue?.trim()?.length > 0 && (
          <styles.SeachWrapper>
            {" "}
            <Search onClick={searchHandler} />
          </styles.SeachWrapper>
        )}
        {!errorMsg && (
          <styles.SeachWrapper>
            {" "}
            <Search onClick={clickHandler} />
          </styles.SeachWrapper>
        )}
        {errorMsg &&
          searchInputValue?.trim()?.length <
            selectedSearchFieldProperties?.validLength &&
          searchInputValue?.trim()?.length > 0 && (
            <styles.ErrorMsg>
              Please enter the {selectedSearchFieldProperties?.validLength}{" "}
              digit {selectedSearchFieldProperties.dispValue}
            </styles.ErrorMsg>
          )}
      </div>

      <div className="ml-auto">
        <SelectSearchInputParam
          searchInputParam={globalFilter?.searchField ?? "psid"}
          setSearchInputParam={(value) =>
            setGlobalFilter({
              ...globalFilter,
              searchField: value,
              ...emptySearchFields,
            })
          }
          searchParamTitleMap={searchInputParams}
          styles={{ width: "230px" }}
        />
      </div>
    </div>
  );
};
